import { render, staticRenderFns } from "./MissedCallMessage.vue?vue&type=template&id=192a65ed&"
import script from "./MissedCallMessage.vue?vue&type=script&lang=js&"
export * from "./MissedCallMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports